import { View } from '@lib/fetch/getViewByUri';
import { PageHeaderProps } from './PageHeader';
import { PageHeaderRoot } from './PageHeaderRoot';

export const PageHeaderDefault = ({ view }: PageHeaderProps<View>) => {
  return <PageHeaderRoot />;
};
